

<section class="back-eee">
    <div class="hero-section">
        <div class="hero-container">
            <ngx-slick-carousel class="carousel"
                                #slickModal="slick-carousel"
                                [config]="slideConfig">
                <div ngxSlickItem *ngFor="let item of dataSourceSlide.data" class="slide">

                    <img [src]="apiURL + item.photoPath1"
                         [alt]=""
                         class="slide-img" />

                </div>
            </ngx-slick-carousel>


        </div>
    </div>

    <!--<owl-carousel-o [options]="heroSlides">
        <ng-template carouselSlide *ngFor="let item of dataSourceSlide.data;">-->
    <!--<div class="main-banner" style="{{ 'background-image: linear-gradient(0deg, rgb(3, 20, 252,0.5),rgb(252, 3, 3,0.5)), url(' + apiURL + item.photoPath1 + ');width:100% ; height:10vh; ' }} ">-->
    <!--<div class="image-container" style="width: 100%; height: 10vh;" [ngStyle]="{
        'background-image': 'url(' + apiURL + item.photoPath1 + ')',
        'background-size': 'cover',
        'background-position': 'center'
    }">

                    <div class="container" style="">-->
    <!--<div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="hero-slider-content">

                    <ng-template *ngIf="SelectedLanguage == 'ar' ; then other_ItemAr  ; else other_ItemEn">
                    </ng-template>
                    <ng-template #other_ItemAr>
                        <span class="pr-text">{{item.textAr1}}</span>
                        <h2 class="head-text">{{item.textAr2}}</h2>
                        <p>{{item.textAr3}}</p>
                        <div class="hero-slider-btn">
                            <a routerLink="/shop" class="btn  btn-lg"><i class="ri-shopping-cart-line"></i> {{item.buttonTextAr}}</a>

                        </div>
                    </ng-template>
                    <ng-template #other_ItemEn>
                        <span class="pr-text">{{item.textEn1}}</span>
                        <h2 class="head-text">{{item.textEn2}}</h2>
                        <p>{{item.textEn3}}</p>
                        <div class="hero-slider-btn">
                            <a routerLink="/shop" class="btn  btn-lg"><i class="ri-shopping-cart-line"></i> {{item.buttonTextEn}}</a>
                        </div>
                    </ng-template>



                </div>
            </div>
        </div>
    </div>-->
    <!--</div>
            </div>
        </ng-template>
    </owl-carousel-o>-->


    <section class="listing-area p-0">
        <app-category></app-category>
    </section>


    <section class="listing-area">
        <app-latest-product></app-latest-product>
    </section>


    <!--<section class="listing-area  ptb-100">
        <app-occasion-categories></app-occasion-categories>
    </section>-->



    <!--<section class="process-area ptb-100">-->
        <!-- <section class="about-area ptb-100"> -->
        <!--<app-features></app-features>

    </section>-->

    <section class="listing-area">
        <app-most-sales></app-most-sales>
    </section>


    <section class="products-area">
        <app-offer></app-offer>

    </section>
</section>



